export default __webpack_public_path__ + "static/media/wishwellbyonegift.1edcdd30.svg";